import * as React from 'react';

import {getMultipleEntityType} from 'nutshell-core/utils/get-multiple-entity-type';

// @ts-expect-error
import {TrashEmptyIcon} from 'shells/icon/svg/trash-empty-icon';

import type {TrashFilterOption} from './trash-filters';

import styles from './trash-empty.module.css';

type Props = {
    selectedFilter: TrashFilterOption;
    errorMessage?: string;
};

export class TrashEmpty extends React.PureComponent<Props> {
    render() {
        const emptyMessage =
            this.props.selectedFilter === 'all'
                ? 'Nothing in the trash'
                : `No ${getMultipleEntityType(this.props.selectedFilter)} in the trash`;

        return (
            <div className={styles.container}>
                <TrashEmptyIcon className={styles['icon-trash']} size={100} />
                {this.props.errorMessage ? (
                    <h3 className={styles['empty-text']}>{this.props.errorMessage}</h3>
                ) : (
                    <h3 className={styles['empty-text']}>{emptyMessage}</h3>
                )}
            </div>
        );
    }
}
